declare namespace $ {

	type $mol_button_minor__hint_shm_hitalama_entity_catalog_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_shm_hitalama_entity_catalog_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_entity_catalog['add'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_hitalama_entity_catalog_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $shm_hitalama_entity_page__entity_shm_hitalama_entity_catalog_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_entity_catalog['entity'] >
		,
		ReturnType< $shm_hitalama_entity_page['entity'] >
	>
	type $shm_hitalama_entity_page__cut_shm_hitalama_entity_catalog_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_entity_catalog['cut'] >
		,
		ReturnType< $shm_hitalama_entity_page['cut'] >
	>
	export class $shm_hitalama_entity_catalog extends $mol_book2_catalog {
		add( next?: any ): any
		Add_icon( ): $mol_icon_plus
		Add( ): $mol_button_minor
		entity( id: any): $giper_baza_entity
		cut( id: any): any
		menu_title( ): string
		param( ): string
		list( ): any
		spread_pages_deep( ): readonly(any)[]
		menu_tools( ): readonly(any)[]
		title_default( ): string
		entities( ): readonly($giper_baza_entity)[]
		Page( id: any): $shm_hitalama_entity_page
	}
	
}

//# sourceMappingURL=catalog.view.tree.d.ts.map